import React from 'react';
import { PeopleFill, CameraVideoFill, GeoAltFill, CalendarFill } from 'react-bootstrap-icons';
import TreasureMap from './TreasureMap';
import { formatDate } from '../utils/date';

const ARPosterReport = ({ arPosterEvents, totalSignups }) => {
  if (!arPosterEvents || arPosterEvents.length === 0) {
    return <p>표시할 AR 포스터 이벤트가 없습니다.</p>;
  }

  return (
    <div>
      {arPosterEvents.map(event => {
        const lat = parseFloat(event.latitude);
        const lng = parseFloat(event.longitude);
        const dist = parseFloat(event.distance);
        const hasLocation = !isNaN(lat) && !isNaN(lng) && dist > 0;

        const circles = hasLocation
          ? [{ key: event.eventKey, label: event.eventName, latitude: lat, longitude: lng, radius: dist }]
          : [];

        return (
          <div key={event.eventKey} className="card mb-4 shadow-sm">
            <div className="card-header bg-success text-white">
              <h3 className="mb-0">{event.eventName} ({event.statusName})</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="card mb-3">
                    <div className="card-header">
                      <h5 className="mb-0">이벤트 요약</h5>
                    </div>
                    <div className="card-body">
                      <p className="card-text">
                        <CalendarFill className="me-2" />
                        <strong>기간:</strong> {formatDate(event.startDate)} ~ {formatDate(event.endDate)}
                      </p>
                      <p className="card-text">
                        <PeopleFill className="me-2" />
                        <strong>총 가입자:</strong> {totalSignups} 명
                      </p>
<p className="card-text">
                        <CameraVideoFill className="me-2" />
                        <strong>영상 시청 수:</strong> {event.videoViewCount} 회
                      </p>
                    </div>
                  </div>
                </div>
                {circles.length > 0 && (
                  <div className="col-md-8">
                    <div className="card mb-3">
                      <div className="card-header">
                        <h5 className="mb-0"><GeoAltFill className="me-2" />AR 포스터 위치 및 인식 반경</h5>
                      </div>
                      <div className="card-body">
                        <div style={{ border: '1px solid #ddd', borderRadius: '0.25rem', height: '300px' }}>
                          <TreasureMap circles={circles} />
                        </div>
                        <table className="table table-bordered table-striped mt-3">
                          <thead className="table-dark">
                            <tr>
                              <th>이벤트명</th>
                              <th>위도</th>
                              <th>경도</th>
                              <th>인식 반경</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{event.eventName}</td>
                              <td>{event.latitude}</td>
                              <td>{event.longitude}</td>
                              <td>{event.distance}m</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ARPosterReport;
